import React from 'react';

import aiLM from '@assets/vaults/tabs/ailm.svg?url';
import aLMIcon from '@assets/vaults/tabs/alm.svg?url';
import lPIcon from '@assets/vaults/tabs/lp.svg?url';
import multiFarmIcon from '@assets/vaults/tabs/multi-farm.svg?url';
import singleFarmIcon from '@assets/vaults/tabs/single-farm.svg?url';
import singleIcon from '@assets/vaults/tabs/single.svg?url';

import { ConnectorRangeWidth } from '@app-types/vaults/vault.types';

export const DEFAULT_LEVEL_FROM = 0;

export const DEFAULT_LEVEL_TO = 100;

export const DEFAULT_VAULT_NAME = 'Vault Token';

export const DEFAULT_VAULT_SYMBOL = 'VT';

export const AILM_DOCS = 'https://docs.dexfi.com/dexvaults/dexfis-ailm';

export const DEX_DAO_DOCS = 'https://docs.dexfi.com/dexfi-ecosystem/dexdao';

export enum SortDestination {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum ActionType {
  Deposited = 'Deposited',
  Migrated = 'Migrated',
  Harvested = 'Harvested',
  Withdrawn = 'Withdrawn',
  Swapped = 'Swapped',
  ConvertlessWithdrawn = 'ConvertlessWithdrawn',
  ConvertlessDeposited = 'ConvertlessDeposited',
  EmergencyWithdrawn = 'EmergencyWithdrawn',
}

export const ACTION_TYPE_TITLES: Record<ActionType, string> = {
  [ActionType.Deposited]: 'Deposited',
  [ActionType.Migrated]: 'Migrated',
  [ActionType.Harvested]: 'Harvested',
  [ActionType.Withdrawn]: 'Withdrawn',
  [ActionType.Swapped]: 'Swapped',
  [ActionType.ConvertlessWithdrawn]: 'ConvertLess Withdrawn',
  [ActionType.ConvertlessDeposited]: 'ConvertLess Deposited',
  [ActionType.EmergencyWithdrawn]: 'Emergency Withdrawn',
};

export enum FarmType {
  V2 = 'v2',
  V3 = 'v3',
}

export enum ViewModes {
  List = 'list',
  Grid = 'grid',
}

export enum VaultsTypeTab {
  All = 'all',
  Saved = 'saved',
  My = 'my',
  Profit = 'profit',
}

export enum VaultsFilterTab {
  Single = 'single',
  Strategy = 'strategy',
}

export enum FarmsFilterTab {
  Single = 'single',
  LP = 'v2',
  V3 = 'v3',
}

export enum V3FarmsFilterTab {
  ALM = 'alm',
  Ailm = 'ailm',
}

export enum TagType {
  New = 'new',
}

export enum SortBy {
  Popularity = 'depositors_count',
  Risk = 'risk_level',
  TVL = 'tvl',
  APY = 'apy',
  Daily = 'daily_apy',
  Default = 'default',
  AccountInvestment = 'account_investment',
  Profit = 'profit',
  Liquidity = 'liquidity',
  DepositsWithdrawsSum = 'deposits_withdraws_sum',
  SyntheticPriceUsdRatioAllTime = 'synthetic_price_usd_all_time',
  SyntheticPriceUsdRatioWeekly = 'synthetic_price_usd_weekly',
}

export enum FarmSortBy {
  APR = 'apr',
  TVL = 'tvl',
  Risk = 'risk_level',
  APR_48 = 'apr_48h',
  WeekAPR = 'apr_week',
  AdditionalData = 'additional_date',
}

export const TAG_TITLE = {
  [TagType.New]: 'New',
};

export const VAULTS_TABs = [
  {
    label: 'All vaults',
    value: VaultsTypeTab.All,
  },
  {
    label: 'Saved vaults',
    value: VaultsTypeTab.Saved,
  },
  {
    label: 'My positions',
    value: VaultsTypeTab.My,
  },
  {
    label: 'My profit',
    value: VaultsTypeTab.Profit,
  },
];

export const VAULTS_MOB_TABs = [
  {
    label: 'All',
    value: VaultsTypeTab.All,
  },
  {
    label: 'Saved',
    value: VaultsTypeTab.Saved,
  },
  {
    label: 'My',
    value: VaultsTypeTab.My,
  },
  {
    label: 'Profit',
    value: VaultsTypeTab.Profit,
  },
];

export const DEFAULT_VAULTS_TAB = VaultsTypeTab.All;

export const VAULTS_FILTER_TABs = [
  {
    label: 'Farm',
    value: VaultsFilterTab.Single,
    icon: <img src={singleFarmIcon} alt="" />,
  },
  {
    label: 'Strategy',
    value: VaultsFilterTab.Strategy,
    icon: <img src={multiFarmIcon} alt="" />,
  },
];

export const FARMS_FILTER_TABs = [
  {
    label: 'Single',
    value: FarmsFilterTab.Single,
    icon: <img src={singleIcon} alt="" />,
  },
  {
    label: 'LP',
    value: FarmsFilterTab.LP,
    icon: <img src={lPIcon} alt="" />,
  },
  {
    label: 'v3',
    value: FarmsFilterTab.V3,
    icon: <img src={aLMIcon} alt="" />,
  },
];

export const ALL_FARM_TYPES = FARMS_FILTER_TABs.map((tab) => tab.value);

export const V3_FARMS_FILTER_TABs = [
  {
    label: 'ALM',
    value: V3FarmsFilterTab.ALM,
    icon: <img src={aLMIcon} alt="" />,
  },
  {
    label: 'AiLM',
    value: V3FarmsFilterTab.Ailm,
    icon: <img src={aiLM} alt="" />,
    tagType: TagType.New,
  },
];

export const SORT_VAULTS = [
  {
    name: 'Deposited',
    value: SortBy.AccountInvestment,
  },
  {
    name: 'APY',
    value: SortBy.APY,
  },
  {
    name: 'Daily',
    value: SortBy.Daily,
  },
  {
    name: 'TVL',
    value: SortBy.TVL,
  },
  {
    name: 'Liquidity',
    value: SortBy.Liquidity,
  },
  {
    name: 'Risk',
    value: SortBy.Risk,
  },
];

export const SORT_VAULTS_MOB = [
  {
    name: 'Default',
    value: SortBy.Default,
  },
  ...SORT_VAULTS,
  {
    name: 'Liquidity',
    value: SortBy.Liquidity,
  },
  {
    name: 'Deposit',
    value: SortBy.AccountInvestment,
  },
  {
    name: 'Profit',
    value: SortBy.Profit,
  },
  {
    name: 'Popular',
    value: SortBy.Popularity,
  },
];

export const DEFAULT_VAULT_DIVIDER = 18;

export const MAX_FARMS_LIST = 2;

export const MAX_FARMS_GRID = 2;

export const FARMS_SORT_BY = [
  {
    name: 'APR (24 h)',
    value: FarmSortBy.APR,
  },
  {
    name: 'APR (48 h)',
    value: FarmSortBy.APR_48,
  },
  {
    name: 'APR (week)',
    value: FarmSortBy.WeekAPR,
  },
  {
    name: 'Liquidity',
    value: FarmSortBy.TVL,
  },
  {
    name: 'Date Added',
    value: FarmSortBy.AdditionalData,
  },
  {
    name: 'Risk level',
    value: FarmSortBy.Risk,
  },
];

export const RANGES = [
  {
    label: 'Full',
    value: ConnectorRangeWidth.Full,
  },
  {
    label: 'Safe',
    value: ConnectorRangeWidth.Safe,
  },
  {
    label: 'Common',
    value: ConnectorRangeWidth.Common,
  },
  {
    label: 'Custom',
    value: ConnectorRangeWidth.Custom,
  },
];
